import React, { useState } from "react";
import { Button, Input } from "components";
import ctl from "@netlify/classnames-template-literals";
import { useForm } from "react-hook-form";

const MailingListForm = ({ isDark, buttonText }) => {
  const [isLoading, setIsLoading] = useState(false);

  const inputWrapperStyle = ctl(`
${inputWrapperBaseStyle}
${isDark ? "bg-secondary" : "bg-secondary-100"}
`);

  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();

  const addToMailingList = async (data, e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await fetch(
        `https://api.mailgun.net/v3/lists/transform@tech.parkwayprojects.com/members?subscribed=true&address=${data.emailAddress}`,
        {
          method: "POST",
          headers: {
            authorization: `Basic YXBpOmtleS0zYTM5ZjgxOGIxZWJjM2YyYTE1MzNmMThmZDkzMzAyZQ==`,
          },
        }
      )
        .then(res => res.json())
        .then(data =>
          alert("You have been successfully added to our mailing list")
        )
        .catch(e => {
          alert("Something went wrong kindly try again");
        });
    } catch (error) {
      alert("Something went wrong kindly try again");
    } finally {
      setIsLoading(false);
      resetField();
    }
  };
  return (
    <form onSubmit={handleSubmit(addToMailingList)}>
      <div className={inputWrapperStyle}>
        <Input
          placeholder="Enter your email address"
          register={register("emailAddress", {
            required: true,
          })}
          error={errors?.emailAddress?.message}
          isDark={isDark}
        />
        <div className="lg:ml-2.5">
          <Button
            text={buttonText}
            variant="primary"
            size="small"
            hasArrow
            isLoading={isLoading}
            // disabled={!isDirty || !isValid}
          />
        </div>
      </div>
    </form>
  );
};

const inputWrapperBaseStyle = ctl(`
flex 
items-center
justify-between
xl:mt-0
mt-[18px]
mb-16
border
border-primary
rounded-full
md:p-2
p-1
relative
`);

MailingListForm.defaultProps = {
  isDark: false,
};

export { MailingListForm };
